import React from 'react'
import { Switch, Route } from 'react-router-dom'
import slug from 'constants/slug'
import LicenseList from './license-list'

export default props => (
  <Switch>
    <Route
      exact
      path={slug.license.list}
      render={matchProps => <LicenseList {...matchProps} {...props} />}
    />
  </Switch>
)



// WEBPACK FOOTER //
// ./src/containers/license/index.js